import React, { useEffect } from 'react'
import { FilterValues } from '../utils'
import { filterStore } from '@/src/types/filterData'

const useUpdatefilterValues = () => {
  const { appliedValues, activeQuickFilter } = filterStore()

  useEffect(() => {
    const filters: { [key: string]: unknown } = {}
    const copyAppliedValues = JSON.parse(JSON.stringify(appliedValues))

    Object.keys(copyAppliedValues).forEach(item => {
      const key = Number(item) as keyof FilterValues // Explicitly cast to number
      const filterValue = copyAppliedValues[key]
      if (filterValue && filterValue.name) {
        filters[String(filterValue.name)] = filterValue.value
      }
    })
    // console.log("filters", filters);
  }, [appliedValues, activeQuickFilter])
}

export default useUpdatefilterValues
